module.exports = __webpack_public_path__ + "img/sbzc_13.5e475210.jpg";